import { Injectable } from '@angular/core';
import { ListDecorator } from '../constants-types/PiList.model';
import { Person } from '../core-data-model/Person.model';
import { StringUtilities } from '../core-utilities/String.utility';
import { Util } from '../core-utilities/Util';

export type EmailSharingOptions = {
    defaultSubject: string;
    defaultMessage: string;
    addButtonText?: string;
    emailToSubjectGroupText: string;
    reportNameForLogging?: string;
    showBackButton?: boolean;
    hideBorder?: boolean;
    loadingMessage?: string;
};

export type EmailSharingCommand = {
    subject: string;
    message: string;
    emails: string[];
};

export enum EmailModalState {
    Opened = 1,
    Loading,
    Closed
}

@Injectable({ providedIn: 'root' })
export class EmailListFactory {
    constructor(private util: Util) {}
    new(oldList?: Iterable<string>) {
        return new EmailList(oldList, this.util);
    }
}

/*
This class is immutable!!!
*/
export class EmailList extends ListDecorator<string> {
    constructor(
        oldList?: Iterable<string>,
        private util?: Util
    ) {
        super(oldList);
    }

    add(item: Person | string): EmailList {
        const emailToAdd = item instanceof Person ? item.email : item;
        if (emailToAdd && !this.includes(emailToAdd)) {
            return this.push(emailToAdd) as EmailList;
        }
        return this;
    }

    // TODO - make into decorator
    _includes: { [key: string]: boolean } = {};
    includes(toCheck: string): boolean {
        if (!this.util.hasValue(this._includes[toCheck])) {
            this._includes[toCheck] = !!this.find(
                (item) => item.toLowerCase() === toCheck.toLowerCase()
            );
        }
        return this._includes[toCheck];
    }

    remove(toRemove: string): EmailList {
        return this.makeMyself(
            this.filter(
                (item): item is string =>
                    item.toLowerCase() !== toRemove.toLowerCase()
            )
        );
    }
    produceEmailList(): string {
        return this.toArray().join(',');
    }

    addMany(item: string[]) {
        return this.makeMyself(
            this.concat(item.filter((subItem) => !this.includes(subItem)))
        );
    }

    _validate: boolean | 'notset' = 'notset';
    validate() {
        if (this._validate === 'notset') {
            this._validate = this.every((email) =>
                StringUtilities.rawEmailValidation(email)
            );
        }

        return this._validate;
    }

    makeIntoArray() {
        return this.filter((email): email is string => !!email)
            .map((email) => email.trim())
            .toArray();
    }

    protected makeMyself(oldList: any): this {
        // The 'new' is requried to actually create a new object.
        // Otherwise the constructor will modify your existing
        // object which violates the immutability
        return new (<any>this.constructor)(oldList, this.util);
    }
}
